<template>
  <div class="lost-password-modal">
    <v-dialog
      v-model="show"
      max-width="400"
    >
      <v-card>
        <v-card-title
          class="lost-password-modal__title"
          primary-title
        >
          LOST PASSWORD
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-row>
            <v-col>
              Please enter your email address below to start the process of resetting your password
            </v-col>
          </v-row>

          <v-form
            ref="emailForm"
            v-model="isFormValid"
            class="lost-password-modal__form"
            @submit.prevent="submitForm"
          >
            <v-row class="lost-password-modal_row">
              <v-col class="lost-password-modal__col">
                <v-text-field
                  v-model="email"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="E-mail address*"
                  placeholder="Enter your email"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="lost-password-modal__actions">
          <v-btn
            class="lost-password-modal__submit"
            color="blue"
            large
            :loading="isSubmitProcessing"
            type="submit"
            @click="submitForm"
          >
            RESET PASSWORD
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      rules,
      email: '',
      isSubmitProcessing: false,
      isFormValid: true,
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },


  watch: {
    show(val) {
      this.email = '';
      if (!val) this.$refs.emailForm.resetValidation();
    },
  },

  methods: {
    ...mapActions('password', [
      'recoverPassword',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    submitForm() {
      this.$refs.emailForm.validate();

      if (this.isFormValid) {
        this.isSubmitProcessing = true;

        this.recoverPassword(this.email)
          .then(() => {
            this.closeModal();
          })
          .finally(() => {
            this.isSubmitProcessing = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lost-password-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 24px 24px 24px 24px;
    justify-content: flex-end;
  }

  &__submit {
    font-weight: 400;
    color: white;
    width: 256px;
  }
}
</style>
